import * as React from 'react';

import type {User, Team, FormattedValue} from 'nutshell-core/types';

import {ListView} from 'shells/list-view/list-view';

// @ts-expect-error
import {LeaderboardEmptyState} from './leaderboard-empty-state';
// @ts-expect-error
import {LeaderboardListRow} from './leaderboard-list-row';

import styles from './leaderboard.module.css';

type TopEntity = {
    id: string;
    type: 'users' | 'teams';
    count: string;
    total?: FormattedValue;
};

type Props = {
    leaderboardType: string;
    topEntities: TopEntity[];
    users: User[];
    teams: Team[];
};

export class Leaderboard extends React.Component<Props> {
    render() {
        if (!this.props.topEntities) {
            return <LeaderboardEmptyState isError={true} />;
        }

        // @ts-expect-error
        const usersAndTeams = this.props.users.concat(this.props.teams);
        const leaderboardData = this.props.topEntities.map((entity) => {
            return {
                id: entity.id,
                rowType: this.props.leaderboardType,
                entity: usersAndTeams.find((userOrTeam) => userOrTeam.id === entity.id),
                count: entity.count,
                total: entity.total,
            };
        });

        return (
            <div className={styles.leaderboard}>
                <ListView
                    collection={leaderboardData}
                    renderRow={(data, index) => (
                        <LeaderboardListRow key={data.id} position={index + 1} {...data} />
                    )}
                    specialStates={[
                        {
                            shouldRender: () => this.props.topEntities.length === 0,
                            component: <LeaderboardEmptyState isError={false} />,
                        },
                    ]}
                />
            </div>
        );
    }
}
